import { render, staticRenderFns } from "./v-sliderFoto-item.vue?vue&type=template&id=a4df3f3c&"
import script from "./v-sliderFoto-item.vue?vue&type=script&lang=js&"
export * from "./v-sliderFoto-item.vue?vue&type=script&lang=js&"
import style0 from "./v-sliderFoto-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports